import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { AccountService, MatchOtherValidator, MessageBase, PasswordNotMatch, ResetPassword } from '@ebeihilfe/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { OverlayService } from '@ebeihilfe/web-logic';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'portal-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordComponent implements OnDestroy, OnInit {
  private readonly accountService = inject(AccountService);
  private readonly cd = inject(ChangeDetectorRef);
  private readonly formBuilder = inject(FormBuilder);
  private readonly message = inject(MessageBase);
  private readonly route = inject(ActivatedRoute);
  private readonly spinnerService = inject(OverlayService);

  public resetPasswordForm: FormGroup;
  public sendedRequest = false;
  public newPasswordRepeatErrors = [PasswordNotMatch];

  private destroyed$: Subject<boolean> = new Subject();
  private personalNumber: string;
  private resetPasswordCode: string;

  public get password(): AbstractControl {
    return this.resetPasswordForm.get('password');
  }

  public get passwordRepeat(): AbstractControl {
    return this.resetPasswordForm.get('passwordRepeat');
  }

  public ngOnInit(): void {
    this.initForm();

    const params: Params = this.route.snapshot.params;
    if (params) {
      this.personalNumber = params.pn;
      this.resetPasswordCode = params.code;
    }
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.unsubscribe();
  }

  public async submitResetPasswordForm(): Promise<void> {
    const payload: ResetPassword = {
      personalNumber: this.personalNumber,
      code: this.resetPasswordCode,
      password: this.password.value,
      passwordRepeated: this.passwordRepeat.value,
    };

    this.spinnerService.show();

    this.accountService
      .setNewPassword(payload)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: () => {
          this.sendedRequest = true;
          this.spinnerService.hide();
          this.cd.markForCheck();
        },
        error: (error: { message: string; title: string }) => {
          this.message.showError(error);
          this.spinnerService.hide();
        },
      });
  }

  private initForm(): void {
    this.resetPasswordForm = this.formBuilder.group({
      password: [''],
      passwordRepeat: ['', MatchOtherValidator('password')],
    });
  }
}
